import React from "react";
import { Select } from "antd";
import "antd/dist/antd.css";
import { IoMdArrowDropdown } from "react-icons/io";

const { Option } = Select;

export default function SelectFilterClear({
  headerSelectFilterClear,
  handleChange,
  data,
  keyvalue,
  keyname,
  defaultValue,
  require ,
  styleSelect,
  styleDiv,
  error,
  textError,
  classNameDiv,
  styleHeader,
  classNameTextHeader,
  value
}) {
  const mgTop = {
    marginTop: "10px",
  };
  function checkRequire(require) {
    if (require) {
      return <span style={{ color: "red" }}>*</span>;
    }
  }
  return (
    <div className={classNameDiv} style={ styleDiv ? styleDiv : mgTop}>
      <p className={classNameTextHeader ?classNameTextHeader  : "txt-sub-explanation1"} style={styleHeader} > {headerSelectFilterClear} {checkRequire(require)} </p>
      <Select
      value={value}
        onChange={handleChange}
        defaultValue={defaultValue ? defaultValue : null}
        style={ styleSelect ? styleSelect : { width: "100%" , marginTop: "6px"  }}
        suffixIcon={
          <IoMdArrowDropdown
            style={{ fontSize: "1.7rem", marginLeft: "-20px" }}
          />
        }
      >
        {data.map((dataSelect) => (
          <Option key={dataSelect[keyvalue]} value={dataSelect[keyvalue]}>
            {" "}
            {dataSelect[keyname]}{" "}
          </Option>
        ))}
      </Select>
      {error && <p className="txt-show-error-required"> {textError} </p>}
    </div>
  );
}
